import { AppState } from 'store/root.reducer'

export const selectAutoChecksState = (state: AppState) => state?.autochecks

export const selectLoadingAutoCheck = (state: AppState) => selectAutoChecksState(state)?.loadingAutoChecks

export const selectAutoChecksStatus = (state: AppState) => selectAutoChecksState(state)?.status

export const selectAutoChecks = (state: AppState) => selectAutoChecksState(state)?.checks
